import { SubscriptionTier } from '@/types/subscription';

export const SUBSCRIPTION_TIERS: SubscriptionTier[] = [
  {
    id: 'freemium',
    name: 'Freemium',
    price: 0,
    billingPeriod: 'month',
    stripeId: '',
    target: 'consumer',
    features: [
      '✅ Dashboard access',
      '✅ Basic Estimator Engine',
      '✅ SmartBuy Analyzer (basic)',
      '✅ Homebuyer Checklist',
      '✅ Analytics Dashboard',
      '✅ OfferScope™ Investor Analytics',
      '✅ Rental property analysis',
      '✅ ROI calculations',
      '✅ Multi-property comparisons (up to 25)',
      '✅ Profile & Settings',
      '✅ Community support',
      '✅ 5 calculations per month'
    ],
    limitations: {
      calculationsPerMonth: 5,
      reportsPerMonth: 0,
      propertiesTracked: 25
    }

  },
  {
    id: 'pro',
    name: 'Pro',
    price: 9,
    billingPeriod: 'month',
    stripeId: 'price_1Rjc7tDHerWbKqqdaqk9WMeE',
    target: 'consumer',
    popular: true,
    features: [
      'Everything in Freemium',
      'Unlimited calculations',
      'SmartBuy Analyzer (advanced)',
      'Unified Calculator',
      'PDF report downloads',
      'AI-powered guidance',
      'Priority support'
    ]
  },
  {
    id: 'investor',
    name: 'Investor',
    price: 19,
    billingPeriod: 'month',
    stripeId: 'price_1Rjc9mDHerWbKqqdkPS3L3Qu',
    target: 'investor',
    features: [
      'Everything in Pro',
      'Investor Analytics Dashboard',
      'Rental property analysis',
      'ROI calculations',
      'Tax impact modeling',
      'Multi-property comparisons',
      'Investment portfolio tracking (up to 25 properties)'
    ],
    limitations: {
      propertiesTracked: 25
    }
  },
  {
    id: 'agent_pro',
    name: 'Agent Pro',
    price: 49,
    billingPeriod: 'month',
    stripeId: 'price_1RjcBODHerWbKqqdkEhfIBFe',
    target: 'agent',
    features: [
      'Everything in Investor',
      'Property Tax Database',
      'Community Intelligence',
      'Property Comparison Tools',
      'AI ChatBot',
      'Co-branded reports',
      'Client portal access',
      'CRM integrations (coming soon)',
      'Lead capture tools',
      'White-label calculators'
    ]
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: 0, // Custom pricing
    billingPeriod: 'month',
    stripeId: 'contact_sales',
    target: 'enterprise',
    features: [
      'Everything in Agent Pro',
      'Full white-label platform',
      'API access',
      'Admin dashboard',
      'Dedicated support',
      'Custom integrations',
      'Unlimited team members'
    ]
  }
];

export const getTierById = (tierId: string): SubscriptionTier | undefined => {
  return SUBSCRIPTION_TIERS.find(tier => tier.id === tierId);
};

export const getTiersByTarget = (target: string): SubscriptionTier[] => {
  return SUBSCRIPTION_TIERS.filter(tier => tier.target === target);
};

// Tier hierarchy for comparison
const TIER_HIERARCHY: Record<string, number> = {
  freemium: 0,
  pro: 1,
  investor: 2,
  agent_pro: 3,
  enterprise: 4
};

export const compareTiers = (currentTier: string, requiredTier: string): boolean => {
  return (TIER_HIERARCHY[currentTier] || 0) >= (TIER_HIERARCHY[requiredTier] || 0);
};